import URL from '../../config/url'
import Axios from 'axios'

export const PAGES = 'PAGES'

export const setPages = payload => ({
  type: PAGES,
  payload,
})

export const fetchPages = () => {
  return async dispatch => {
    const { status, data = [] } = await Axios({
      method: 'get',
      hedaers: {
        'Access-Control-Allow-Origin': '*',
      },
      url: URL + 'api/admin/page',
    })
    if (status === 200) {
      dispatch(
        setPages(
          data.map(({ atemption, data, ...item }) => {
            try {
              const arrPhotos = JSON.parse(atemption)
              const arrList = JSON.parse(data)
              return { ...item, atemption: arrPhotos, data: arrList }
            } catch (error) {
              return { ...item, atemption: [], data: [] }
            }
          })
        )
      )
    }
  }
}
